var _path, _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingElement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 842,
    height: 841,
    viewBox: "0 0 842 841",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M755 548.962C755 662.475 662.974 754.497 549.462 754.5H186.237L192.68 748.057C254.351 686.386 337.999 651.733 425.215 651.731H549.462C606.217 651.727 652.231 605.717 652.231 548.962V424.735C652.231 337.519 686.868 253.872 748.537 192.2L755 185.737V548.962ZM655.743 86.5L649.3 92.9431C587.627 154.615 503.983 189.269 416.765 189.269H292.538C235.781 189.269 189.769 235.281 189.769 292.038V416.265C189.769 503.483 155.115 587.127 93.4431 648.8L87 655.243V292.038C87 178.523 179.023 86.5 292.538 86.5H655.743Z",
    stroke: "url(#paint0_linear_0_439)",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.68 748.057L186.237 754.5H549.462C662.974 754.497 755 662.475 755 548.962V185.737L748.537 192.2C686.868 253.872 652.231 337.519 652.231 424.735V548.962C652.231 605.717 606.217 651.728 549.462 651.731M655.743 86.5L649.3 92.9431C587.627 154.615 503.983 189.269 416.765 189.269H292.538C235.781 189.269 189.769 235.281 189.769 292.038V416.265C189.769 503.483 155.115 587.127 93.4431 648.8L87 655.243V292.038C87 178.523 179.023 86.5 292.538 86.5H655.743Z",
    stroke: "url(#paint1_radial_0_439)",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_0_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.68 748.057L186.237 754.5H549.462C662.974 754.497 755 662.475 755 548.962V185.737L748.537 192.2C686.868 253.872 652.231 337.519 652.231 424.735V548.962C652.231 605.717 606.217 651.728 549.462 651.731M655.743 86.5L649.3 92.9431C587.627 154.615 503.983 189.269 416.765 189.269H292.538C235.781 189.269 189.769 235.281 189.769 292.038V416.265C189.769 503.483 155.115 587.127 93.4431 648.8L87 655.243V292.038C87 178.523 179.023 86.5 292.538 86.5H655.743Z",
    stroke: "url(#paint2_radial_0_439)",
    strokeWidth: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.68 748.057L186.237 754.5H549.462C662.974 754.497 755 662.475 755 548.962V185.737L748.537 192.2C686.868 253.872 652.231 337.519 652.231 424.735V548.962C652.231 605.717 606.217 651.728 549.462 651.731M655.743 86.5L649.3 92.9431C587.627 154.615 503.983 189.269 416.765 189.269H292.538C235.781 189.269 189.769 235.281 189.769 292.038V416.265C189.769 503.483 155.115 587.127 93.4431 648.8L87 655.243V292.038C87 178.523 179.023 86.5 292.538 86.5H655.743Z",
    stroke: "url(#paint3_radial_0_439)",
    strokeWidth: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_0_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.68 748.057L186.237 754.5H549.462C662.974 754.497 755 662.475 755 548.962V185.737L748.537 192.2C686.868 253.872 652.231 337.519 652.231 424.735V548.962C652.231 605.717 606.217 651.728 549.462 651.731M655.743 86.5L649.3 92.9431C587.627 154.615 503.983 189.269 416.765 189.269H292.538C235.781 189.269 189.769 235.281 189.769 292.038V416.265C189.769 462.405 180.071 507.545 161.804 548.962H87V292.038C87 178.523 179.023 86.5 292.538 86.5H655.743Z",
    stroke: "url(#paint4_radial_0_439)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_439",
    x: 81.5,
    y: 81,
    width: 679,
    height: 679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_0_439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_439",
    x: 70.5,
    y: 70,
    width: 701,
    height: 701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_0_439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_439",
    x: 0.5,
    y: 0,
    width: 841,
    height: 841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "effect1_foregroundBlur_0_439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_439",
    x: 84.5,
    y: 84,
    width: 673,
    height: 673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_0_439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_439",
    x1: 421,
    y1: 86.5,
    x2: 421,
    y2: 754.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923077,
    stopColor: "#0B080D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.551 86.5) rotate(70.8132) scale(707.288 147.764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0336538,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#AEFF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEFF30",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.551 86.5) rotate(70.8132) scale(707.288 147.764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0336538,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#AEFF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEFF30",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.551 86.5) rotate(70.8132) scale(707.288 147.764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0336538,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#AEFF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEFF30",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_0_439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.551 86.5) rotate(70.8132) scale(707.288 147.764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0336538,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#AEFF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEFF30",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingElement);
export default __webpack_public_path__ + "static/media/branding-element.6d23f5f44ded115a59434e505bdee8dc.svg";
export { ForwardRef as ReactComponent };